import React, { lazy, Suspense, useState } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../app/auth/Login";
import AdminMainLayout from "../layout/AdminMainLayout";
import { sampleUsers, categoryTabs } from "../../utils/constants/adminControl";
import Tabs from "../reuseable/Tabs";

const CategoryManagement = lazy(() => import("./CategoryManagement"));
const CategoryRegistrations = lazy(() => import("./CategoryRegistrations"));

const DrawerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

const CategoryManagementLandingPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabLoadingFallback = (
    <div
      style={{
        marginTop: 16,
        padding: 20,
        borderRadius: 8,
        background: "#ffffff",
        color: "#666",
      }}
    >
      Loading...
    </div>
  );

  return (
    <>
      <AuthenticatedTemplate>
        <div className="h-[var(--app-height)] overflow-hidden">
          <Box className="flex h-full">
            <AdminMainLayout />

            <Box
              component="main"
              className="flex-1 bg-white px-6 py-4 overflow-hidden"
            >
              <DrawerHeader />

              <div
                style={{
                  borderRadius: 8,
                  padding: 32,
                  minHeight: "calc(100vh - 124px)",
                  boxSizing: "border-box",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                  display: "block",
                }}
                className="bg-[#bb1ccc]/5"
              >
                <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={categoryTabs} />

                <Suspense fallback={tabLoadingFallback}>
                  {activeTab === 0 && <CategoryManagement sampleUsers={sampleUsers} />}
                  {activeTab === 1 && <CategoryRegistrations />}
                </Suspense>
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default CategoryManagementLandingPage;